import PropTypes from "prop-types";
import styles from "./styles";
import global from "../../styles";
import classNames from "classnames";
import { replaceJSX } from "../../utilities/replaceJSX";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";

const TsAndCs = ({ termsText, privacyPolicyText }) => {
  const { languageStrings, localisedLinks } = useLocaleProvider();
  const translate = useTranslate({ languageStrings });
  const links = replaceJSX(
    translate("loyalty_landing_page_intro_hyperlinks"),
    ["%{termslink}", "%{privacypolicylink}"],
    [
      <a
        target="_blank"
        rel="noreferrer"
        href={`${localisedLinks.termsAndConditions}?ctaref=${encodeURIComponent(
          "TsandCs ~ invited landing page"
        )}`}
        key="termslink"
      >
        {termsText}
      </a>,
      <a
        target="_blank"
        rel="noreferrer"
        href={localisedLinks.privacyPolicy}
        key="privacypolicylink"
      >
        {privacyPolicyText}
      </a>,
    ]
  );

  return (
    <div className={classNames(styles.tsAndCsLink, global.leavesden3)}>
      {links}
    </div>
  );
};

TsAndCs.propTypes = {
  termsText: PropTypes.string,
  privacyPolicyText: PropTypes.string,
};

export default TsAndCs;
